// src/store/services/FotografiasDeCasa.js
import feathersClient, {
    makeServicePlugin,
    BaseModel,
  } from '../../feathers-client';
  
  class FotografiasDeCasa extends BaseModel {
    constructor(data, options) {
      super(data, options);
    }
    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'FotografiasDeCasa';
    // Define default properties here
    static instanceDefaults() {
      return {};
    }
  }
  const servicePath = 'fotografias-de-casa';
  const servicePlugin = makeServicePlugin({
    namespaced: true,
    namespace: 'FotografiasDeCasa',
    Model: FotografiasDeCasa,
    service: feathersClient.service(servicePath),
    servicePath,
  });
  
  // Setup the client-side Feathers hooks.
  feathersClient.service(servicePath).hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    after: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: [],
    },
  });
  
  export default servicePlugin;
  